var React = require('react');

function UbuntuKaleidoscopeArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"next-arrow","d":"M8.49,33.9l17-16.78L8.49.1","transform":"translate(-8.14 0.25)","fill":"none","stroke":"#707070","strokeWidth":"1"}));
}

UbuntuKaleidoscopeArrowRight.defaultProps = {"id":"next-arrow","data-name":"next-arrow","viewBox":"0 0 18 34","width":"18","height":"34"};

module.exports = UbuntuKaleidoscopeArrowRight;

UbuntuKaleidoscopeArrowRight.default = UbuntuKaleidoscopeArrowRight;
